import React from 'react';
import ButterToast from 'butter-toast/dist/lean';

import './style.scss';

const TOAST_TIMEOUT_MS = 10000;

function notify({ message, timeout = TOAST_TIMEOUT_MS, container_class = '', icn_class = '' } = {}) {
    ButterToast.raise({
        content: () => ( // eslint-disable-line
            <p className={container_class}><i className={icn_class}/>{message}</p>
        ),
        namespace: 'collaboration-wrapper',
        timeout
    });
}

export function showErrorToast(message = '') {
    notify({
        message,
        timeout: 5000,
        container_class: 'negative',
        icn_class: 'fa fa-ban'
    });
}

export function showSuccessToast(message = '') {
    notify({
        message,
        timeout: 5000,
        container_class: 'positive',
        icn_class: 'fa fa-check'
    });
}
